import config from "@/config"

export function auditReportRegion(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.AUDIT_BASE_URL}/pages/reporting/reportViewer.aspx` +
      "?locationId=10" +
      "&reportFolder=Audit" +
      "&reportFilename=AuditScoreSheet" +
      `&auditId=${encodeURIComponent(row.auditID)}` +
      `&categoryId=${encodeURIComponent(row.categoryId || -1)}` +
      `&respGroupIds=${encodeURIComponent(row.responsibilityGroupId || -1)}` +
      "&internalSpaceTemplateId=-1" +
      "&elementTypeId=-1",
    text: row.regionName,
  }
}

export function auditReportSite(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.AUDIT_BASE_URL}/pages/reporting/reportViewer.aspx` +
      "?locationId=10" +
      "&reportFolder=Audit" +
      "&reportFilename=AuditScoreSheet" +
      `&auditId=${encodeURIComponent(row.auditID)}` +
      `&categoryId=${encodeURIComponent(row.categoryId || -1)}` +
      `&respGroupIds=${encodeURIComponent(row.responsibilityGroupId || -1)}` +
      "&internalSpaceTemplateId=-1" +
      "&elementTypeId=-1",
    text: row.siteName,
  }
}

export function auditReportBuilding(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.AUDIT_BASE_URL}/pages/reporting/reportViewer.aspx` +
      "?locationId=10" +
      "&reportFolder=Audit" +
      "&reportFilename=AuditScoreSheet" +
      `&auditId=${encodeURIComponent(row.auditID)}` +
      `&categoryId=${encodeURIComponent(row.categoryId || -1)}` +
      `&respGroupIds=${encodeURIComponent(row.responsibilityGroupId || -1)}` +
      "&internalSpaceTemplateId=-1" +
      "&elementTypeId=-1",
    text: row.buildingName,
  }
}

export function auditReportFloor(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.AUDIT_BASE_URL}/pages/reporting/reportViewer.aspx` +
      "?locationId=10" +
      "&reportFolder=Audit" +
      "&reportFilename=AuditScoreSheet" +
      `&auditId=${encodeURIComponent(row.auditID)}` +
      `&categoryId=${encodeURIComponent(row.categoryId || -1)}` +
      `&respGroupIds=${encodeURIComponent(row.responsibilityGroupId || -1)}` +
      "&internalSpaceTemplateId=-1" +
      "&elementTypeId=-1",
    text: row.floorName,
  }
}

export function auditReportRoom(fieldName: string, row: any): { url: string, text: string } {
  return {
    url: `${config.AUDIT_BASE_URL}/pages/reporting/reportViewer.aspx` +
      "?locationId=10" +
      "&reportFolder=Audit" +
      "&reportFilename=AuditScoreSheet" +
      `&auditId=${encodeURIComponent(row.auditID)}` +
      `&categoryId=${encodeURIComponent(row.categoryId || -1)}` +
      `&respGroupIds=${encodeURIComponent(row.responsibilityGroupId || -1)}` +
      "&internalSpaceTemplateId=-1" +
      "&elementTypeId=-1",
    text: row.roomName,
  }
}
